<template>
  <j-select-biz-component :width='1000' v-bind='configs' v-on='$listeners' />
</template>

<script>
import JSelectBizComponent from './JSelectBizComponent'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'JSelectPosition',
  components: { JSelectBizComponent },
  props: ['value'],
  data(){
    return {
      settings: {
        name: this.$t('tableHeader.job'),
        displayKey: 'name',
        returnKeys: ['id', 'code'],
        listUrl: `${ MTC_AUTH }sys/position/list`,
        queryParamCode: 'name',
        queryParamText: this.$t('tableHeader.titleName'),
        columns: [
          {
            slotName: 'tableHeader.titleName',
            // title: '职务名称',
            dataIndex: 'name',
            align: 'center',
            width: '30%',
            widthRight: '70%',
            scopedSlots: { title: 'tableHeader.titleName' }
          },
          {
            slotName: 'tableHeader.titleCode',
            // title: '职务编码',
            dataIndex: 'code',
            align: 'center',
            width: '35%',
            scopedSlots: { title: 'tableHeader.titleCode' }
          },
          {
            slotName: 'tableHeader.titleRank',
            // title: '职级',
            dataIndex: 'rank_dictText',
            align: 'center',
            width: '25%',
            scopedSlots: { title: 'tableHeader.titleRank' }
          }
        ]
      }
    }
  },
  computed: {
    configs(){
      return Object.assign({ value: this.value }, this.settings, this.$attrs)
    }
  }
}
</script>

<style lang='less' scoped></style>